module.exports = __webpack_public_path__ + "img/Cargo-bike-left-side.9ffaaaa.svg";